import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  standalone: false,
    selector: 'app-restricted-content-dialog',
    templateUrl: './restricted-content-dialog.component.html',
    styleUrls: ['./restricted-content-dialog.component.scss'],
})
export class RestrictedContentDialogComponent {
    constructor(private ref: DynamicDialogRef, public config: DynamicDialogConfig) {}

    closeDialog() {
        this.ref.close();
    }

    accept() {
        this.ref.close(true);
    }
}
